// @module Tavanoteam.TavanoTeam_Banner_Extension.Banner
define(
	'Banner.View'
	, [
		'banner.tpl'
		, 'CustomContentType.Base.View'
		, 'jQuery'
		, 'underscore'
	]
	, function (
		banner_tpl
		, CustomContentTypeBaseView
		, jQuery
		, _
	) {
		
		'use strict';

		return CustomContentTypeBaseView.extend({

			template: banner_tpl

			// As an example of the 'install' method, we are going to emulate a fetch to a service
			// Until the promise is resolved, you won't be able to edit the settings of this CCT
			// The same could happen with the 'update' method
			, install: function (settings, context_data) {

				this._install(settings, context_data);

				// call some ajax here
				return jQuery.Deferred().resolve();
			}

			// The list of contexts that you may need to run the CCT
			, contextDataRequest: ['item']

			// By default when you drop a CCT in the SMT admin, it will run the 'validateContextDataRequest' method to check that you have
			// all the requested contexts and it will fail if some context is missing.
			, validateContextDataRequest: function validateContextDataRequest() {

				return true;
			}

			, getVerticalAlign: function (vertical_align) {

				vertical_align = parseInt(vertical_align);

				switch (vertical_align) {
					case 2: vertical_align = 'top'; break;
					case 3: vertical_align = 'bottom'; break;
					default: vertical_align = 'center';
				}

				return vertical_align;
			}

			, getHorizontalAlign: function (horizontal_align) {

				horizontal_align = parseInt(horizontal_align);

				switch (horizontal_align) {
					case 2: horizontal_align = 'left'; break;
					case 3: horizontal_align = 'right'; break;
					default: horizontal_align = 'center';
				}

				return horizontal_align;
			}

			, getColorText: function () {

				var textColor = parseInt(this.settings.custrecord_ttbanner_textcolor);

				switch (textColor) {
					case 2: textColor = 'dark'; break;
					case 3: textColor = 'light'; break;
					default: textColor = 'default';
				}

				return textColor;
			}

			, getButtonClasses: function () {

				var buttonClass = parseInt(this.settings.custrecord_ttbanner_buttonstyle);

				switch (buttonClass) {
					case 2: buttonClass = 'secondary'; break;
					case 3: buttonClass = 'tertiary'; break;
					case 4: buttonClass = 'quaternary'; break;
					case 5: buttonClass = 'link'; break;
					default: buttonClass = 'primary';
				}

				return ' tt-ext-banner-content-button-' + buttonClass;
			}

			, getFontSize: function (textFontSize) {

				textFontSize = parseInt(textFontSize);

				switch (textFontSize) {
					case 1: textFontSize = 'xs'; break;
					case 2: textFontSize = 's'; break;
					case 3: textFontSize = 'm'; break;
					case 4: textFontSize = 'l'; break;
					case 5: textFontSize = 'xl'; break;
					case 6: textFontSize = 'xxl'; break;
					case 7: textFontSize = 'xxxl'; break;
					default: textFontSize = 'm';
				}

				return "font-size-" + textFontSize;
			}

			, getFontWeight: function (fontWeight) {

				fontWeight = parseInt(fontWeight);

				switch (fontWeight) {
					case 2: fontWeight = 'light'; break;
					case 3: fontWeight = 'semibold'; break;
					case 4: fontWeight = 'bold'; break;
					default: fontWeight = 'normal';

				}

				return "font-weight-" + fontWeight;
			}

			, getContainerClasses: function () {

				return this.settings.custrecord_ttbanner_container === "T" ? "tt-ext-banner-content-container" : "tt-ext-banner-content-fullwidth";
			}

			, getContentInfoClasses: function () {

				var contentInfoClasses = "";

				// Desktop Content Position
				contentInfoClasses += " tt-ext-banner-content-position-desktop-" + this.getVerticalAlign(this.settings.custrecord_ttbanner_verticalposition_d) + "-" + this.getHorizontalAlign(this.settings.custrecord_ttbanner_horizontalposition_d);
				// Mobile Content Position
				contentInfoClasses += " tt-ext-banner-content-position-mobile-" + this.getVerticalAlign(this.settings.custrecord_ttbanner_verticalposition_m) + "-" + this.getHorizontalAlign(this.settings.custrecord_ttbanner_horizontalposition_m);
				// Desktop Content Alignment
				contentInfoClasses += " tt-ext-banner-content-alignment-desktop-" + this.getHorizontalAlign(this.settings.custrecord_ttbanner_alignment_d);
				// Mobile Content Alignment
				contentInfoClasses += " tt-ext-banner-content-alignment-mobile-" + this.getHorizontalAlign(this.settings.custrecord_ttbanner_alignment_m);
				// Border Radius
				contentInfoClasses += this.settings.custrecord_ttbanner_borderradius === "T" ? " tt-ext-banner-content-border-radius" : "";
				// Text Color
				contentInfoClasses += " text-style-" + this.getColorText(this.settings.custrecord_tt_title_color);
				// Text Shadow
				contentInfoClasses += this.settings.custrecord_ttbanner_textshadow === "T" ? " text-shadow" : "";

				return contentInfoClasses;
			}

			, getContentInfoStyles: function () {

				// content width
				var contentMinWidth = this.settings.custrecord_ttbanner_minwidth;
				var contentMaxWidth = this.settings.custrecord_ttbanner_maxwidth;
				// content padding
				var contentPadding = this.settings.custrecord_ttbanner_padding;
				// content offest
				var contentOffsetVertical = this.settings.custrecord_ttbanner_offsetvertical != "" ? this.settings.custrecord_ttbanner_offsetvertical : 0;
				var contentOffsetHorizontal = this.settings.custrecord_ttbanner_offsethorizontal != "" ? this.settings.custrecord_ttbanner_offsethorizontal : 0;
				// background color
				var contentBackgroundColor = this.settings.custrecord_ttbanner_backgroundcolor != "" ? this.settings.custrecord_ttbanner_backgroundcolor : "transparent";
				// create styles
				var styles = "style='";
				styles += contentMinWidth != "" ? "min-width: " + contentMinWidth + ";" : "";
				styles += contentMaxWidth != "" ? "max-width: " + contentMaxWidth + ";" : "";
				styles += contentPadding != "" ? "padding: " + contentPadding + "px;" : "";
				styles += "margin: " + contentOffsetVertical + "px " + contentOffsetHorizontal + "px;";
				styles += contentBackgroundColor != "transparent" ? "background-color: " + contentBackgroundColor + ";" : "";

				return styles + "'";
			}

			, getTextClasses: function (cms_font_size_value, cms_font_weight_value) {

				var classes = "";

				classes += this.getFontSize(cms_font_size_value) + " ";
				classes += this.getFontWeight(cms_font_weight_value) + " ";

				return classes;
			}

			, getTextStyles: function () {

				var textSpacing = this.settings.custrecord_ttbanner_textspacing != "" ? this.settings.custrecord_ttbanner_textspacing : 15;

				return "style='margin-bottom: " + textSpacing + "px;'";
			}
			, getButtonStyles: function () {

				var buttonSpacing = this.settings.custrecord_ttbanner_buttontopspace != "" ? this.settings.custrecord_ttbanner_buttontopspace : 15;

				return "style='margin-top: " + buttonSpacing + "px;'";
			}

			, getParallaxStyles: function () {

				var parallaxStyle = "style=\"";
				// Parallax Height
				var parallax_height = this.settings.custrecord_ttbanner_parallaxheight ? this.settings.custrecord_ttbanner_parallaxheight : "";
				// Parallax Positoin
				var parallax_position = parseInt(this.settings.custrecord_ttbanner_parallaxposition);

				switch (parallax_position) {
					case 2:
						parallax_position = 'top';
						break;
					case 3:
						parallax_position = 'bottom';
						break;
					default:
						parallax_position = 'center';
				}

				// Create parallax styles
				parallaxStyle += "background-image: url('" + this.settings.custrecord_ttbanner_image_d + "'); ";
				parallaxStyle += "background-position: " + parallax_position + "; ";
				parallaxStyle += parallax_height != "" ? "height: " + parallax_height + "px; " : "";

				return parallaxStyle + "\"";
			}

			, getButtonDataTouchPoint: function () {

				var dataTouchPoint = parseInt(this.settings.custrecord_ttbanner_buttondtp);

				switch (dataTouchPoint) {
					case 2: dataTouchPoint = 'home'; break;
					case 3: dataTouchPoint = 'login'; break;
					case 4: dataTouchPoint = 'register'; break;
					case 5: dataTouchPoint = 'logout'; break;
					case 6: dataTouchPoint = 'customercenter'; break;
					case 7: dataTouchPoint = 'viewcart'; break;
					case 8: dataTouchPoint = 'checkout'; break;
					default: dataTouchPoint = 'none';
				}

				return (dataTouchPoint && dataTouchPoint != 'none' ? 'data-touchpoint="' + dataTouchPoint + '"' : '');
			}

			, getUpperTitleTag: function () {

				var tag = parseInt(this.settings.custrecord_ttbanner_uppertitletag);

				switch (tag) {
					case 2: tag = 'h3'; break;
					case 3: tag = 'h4'; break;
					case 4: tag = 'h5'; break;
					case 5: tag = 'h6'; break;
					default: tag = 'h3';
				}

				return tag;
			}

			, getTitleTag: function () {

				var tag = parseInt(this.settings.custrecord_ttbanner_titletag);

				switch (tag) {
					case 2: tag = 'h2'; break;
					case 3: tag = 'h3'; break;
					case 4: tag = 'h4'; break;
					case 5: tag = 'h5'; break;
					default: tag = 'h1';
				}

				return tag;
			}

			, getContext: function getContext() {

				var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);

				// Button
				var buttonText = this.settings.custrecord_ttbanner_button;
				var buttonLink = this.settings.custrecord_ttbanner_buttonlink;
				var bannerLink = !buttonText && buttonLink ? true : false;

				// Parallax Validation
				var parallax = this.settings.custrecord_ttbanner_parallax === "T" && !isSafari ? true : false;

				return {
					lazyLoad: (typeof lazySizes != 'undefined'), // Lazysizes Plugin check

					// General
					bannerLink: bannerLink,
					contentContainerClasses: this.getContainerClasses(),
					contentInfoClasses: this.getContentInfoClasses(),
					contentInfoStyles: this.getContentInfoStyles(),

					// Images
					desktopImage: this.settings.custrecord_ttbanner_image_d,
					mobileImage: this.settings.custrecord_ttbanner_image_m,
					imageAlt: this.settings.custrecord_ttbanner_imagealt,

					// Imgage Parallax
					parallax: parallax,
					parallaxStyles: this.getParallaxStyles(),

					background: this.settings.custrecord_ttbanner_background,

					// Contents text
					upperTitleTag: this.getUpperTitleTag(),
					upperTitle: this.settings.custrecord_ttbanner_uppertitle,
					titleTag: this.getTitleTag(),
					title: this.settings.custrecord_ttbanner_title,
					descriptionDesktop: this.settings.custrecord_ttbanner_description_d,
					descriptionMobile: this.settings.custrecord_ttbanner_description_m,

					// Contents Classes & Styles
					upperTitleClasses: this.getTextClasses(this.settings.custrecord_ttbanner_uppertitlefontsize, this.settings.custrecord_ttbanner_uppertitlefontwgt),
					titleClasses: this.getTextClasses(this.settings.custrecord_ttbanner_titlefontsize, this.settings.custrecord_ttbanner_titlefontwgt),
					descriptionClasses: this.getTextClasses(this.settings.custrecord_ttbanner_descriptionfontsize, this.settings.custrecord_ttbanner_descriptionfontwgt),
					textStyles: this.getTextStyles(),

					// Button
					buttonText: buttonText,
					buttonLink: buttonLink,
					buttonStyles: this.getButtonStyles(),
					buttonClasses: this.getButtonClasses(),
					buttonDataTouchPoint: this.getButtonDataTouchPoint()
				};
			}
		});
	}
);
